/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import styled from "styled-components";
import Locale from "./Locale";
import { useT } from "../context/i18n";
import track from "../lib/track";

const Footer: React.FC = () => {
  const t = useT();
  const [credits, setCredits] = useState(false);

  return (
    <Wrapper>
      <Left>
        <Locale />
      </Left>
      <Right>
        {credits ? (
          <>
            <span
              dangerouslySetInnerHTML={{
                __html: t("footer.credits"),
              }}
            />{" "}
            &bull;{" "}
            <a
              onClick={() => {
                setCredits(false);
                track("Footer", "Credits", "Close");
              }}
            >
              &times;
            </a>
          </>
        ) : (
          <a
            onClick={() => {
              setCredits(true);
              track("Footer", "Credits", "Open");
            }}
          >
            {t("footer.creditsButton")}
          </a>
        )}{" "}
        &bull;{" "}
        <span
          dangerouslySetInnerHTML={{
            __html: t("footer.byScriptist"),
          }}
        ></span>
      </Right>
    </Wrapper>
  );
};

const Left = styled.div``;

const Right = styled.p`
  margin: 0;
  text-align: right;
`;

const Wrapper = styled.footer`
  align-items: flex-end;
  bottom: 5px;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  left: 8px;
  position: fixed;
  right: 8px;
`;

export default Footer;
